import fa from './fa';
import en from './en';

const messages = {
    en,
    fa
};
export default messages;